<template>
  <div class="tw-max-h-[90vh]">
    <PageHeader>
      <template #header-title>
        {{ $t('Incoming jobs') }}
      </template>
    </PageHeader>

    <IncomingJobsGraphqlTable />
  </div>
</template>

<script lang="ts" setup>
import PageHeader from '@/components/PageHeader.vue'
import { $t } from '@/composables/translation'
import IncomingJobsGraphqlTable from '@/components/Job/Table/IncomingJobsGraphqlTable.vue'
</script>
